
import Button from '../../../componentsNew/Button'
import CircularProgress from '../../../componentsNew/CircularProgress'


export function ButtonAdicionar({ handleClick, disabled, component, className, selectedPosts, countPostsSaved, condicaoMudarTexto, children, esconderCarregar = false }) {
    return (
        <>
            {!(esconderCarregar && condicaoMudarTexto) && <Button
                onClick={handleClick}
                disabled={disabled}
                component={component}
                className={className}
            >
                {condicaoMudarTexto ?
                    <>
                        <CircularProgress component='padrao' className="w-4 h-4 relative" />
                        <>
                            {countPostsSaved === selectedPosts.length && selectedPosts.length > 0
                                && "Aguarde, você será redirecionado."}
                            {countPostsSaved < selectedPosts.length
                                && `Registrando posts ${countPostsSaved} de ${selectedPosts.length}`}
                        </>
                    </> :
                    <>
                        {children}
                    </>
                }
            </Button>}
        </>

    )
}